package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("ChangeSharedPublicPlanResponse")
data class ChangeSharedPublicPlanResponse(
    @JsName("success")
    val success: Boolean,

    @JsName("message")
    val message: String? = null
)